import { Divider as MuiDivider, styled } from "@mui/material";
import { toolbarButtonGroupName } from "../classes.js";
const excludedProps = ["as", "cssVariables", "ownerState", "sx", "theme"];
const Divider = styled(MuiDivider, {
  name: toolbarButtonGroupName,
  overridesResolver: (_props, styles) => [styles.divider],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Divider"
})(({ cssVariables: vars }) => ({
  borderColor: vars.buttonGroupDividerBorderColor,
  marginBottom: vars.buttonGroupDividerMarginBottom,
  marginLeft: vars.buttonGroupDividerMarginLeft,
  marginRight: vars.buttonGroupDividerMarginRight,
  marginTop: vars.buttonGroupDividerMarginTop
}));
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
